/* Aerosol trigger-handle upsell. Selection only; the aerosol controller owns cart submission. */
(function () {
  'use strict';
  if (window.__partifyRequestAerosolAddOn) return;
  let activeRequest = null;
  const styleId = 'partify-aerosol-upsell-style';

  function addStyles() {
    if (document.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .tuap-upsell{box-sizing:border-box;width:min(560px,calc(100vw - 32px));max-width:none;max-height:calc(100vh - 32px);max-height:calc(100dvh - 32px);padding:0;border:0;border-radius:12px;color:#17212e;background:#fff;box-shadow:0 20px 70px #0004;font-family:inherit;overflow:auto;overscroll-behavior:contain}
      .tuap-upsell::backdrop{background:rgba(14,23,38,.55)}
      .tuap-upsell *{box-sizing:border-box}
      .tuap-upsell__header{position:relative;padding:24px 24px 16px}
      .tuap-upsell__header h2{margin:0 36px 8px 0;color:#17212e;font-size:25px;line-height:1.2;font-weight:700}
      .tuap-upsell__context{margin:0 32px 0 0;color:#596575;font-size:13px;line-height:1.5}
      .tuap-upsell__close{position:absolute;top:14px;right:14px;width:40px;height:40px;padding:0;background:transparent;border:0;color:#263345;font-size:28px;cursor:pointer}
      .tuap-upsell__body{padding:0 24px}
      .tuap-upsell__card{display:grid;grid-template-columns:20px 60px minmax(0,1fr) auto;gap:12px;align-items:center;padding:18px 0;border-top:1px solid #e1e5eb}
      .tuap-upsell__check{width:19px;height:19px;margin:0;accent-color:#182d98;cursor:pointer}
      .tuap-upsell__media{width:60px;height:72px;border:0;padding:3px;background:#fff;cursor:zoom-in}
      .tuap-upsell__media img{display:block;width:100%;height:100%;object-fit:contain}
      .tuap-upsell__copy label{display:block;margin:0;color:#17212e;font-size:15px;font-weight:600;line-height:1.4;cursor:pointer}
      .tuap-upsell__copy p{margin:6px 0 0;font-size:12px;color:#657082;line-height:1.5}
      .tuap-upsell__price{font-size:15px;font-weight:600;white-space:nowrap}
      .tuap-upsell__preview{padding:0 0 16px;text-align:center}
      .tuap-upsell__preview[hidden]{display:none}
      .tuap-upsell__preview img{width:100%;max-height:40vh;object-fit:contain}
      .tuap-upsell__footer{margin:0 24px;padding:16px 0 20px;border-top:1px solid #e1e5eb}
      .tuap-upsell__subtotal{display:flex;justify-content:space-between;gap:12px;margin:0 0 8px;font-size:16px;font-weight:600}
      .tuap-upsell__notice{margin:0 0 16px;color:#657082;font-size:12px;line-height:1.5}
      .tuap-upsell__primary,.tuap-upsell__skip{display:block;width:100%;min-height:46px;border-radius:5px;padding:11px 12px;font-family:inherit;font-size:15px;font-weight:600;line-height:1.4;cursor:pointer}
      .tuap-upsell__primary{border:1px solid #182d98;background:#182d98;color:#fff}
      .tuap-upsell__skip{margin-top:8px;border:1px solid #cbd2db;background:#fff;color:#263345}
      .tuap-upsell button:focus-visible,.tuap-upsell input:focus-visible{outline:3px solid #6a9dff;outline-offset:3px}
      @media(max-width:600px){.tuap-upsell{position:fixed;inset:auto 0 0;margin:0;width:100%;max-height:88vh;max-height:88dvh;border-radius:14px 14px 0 0}.tuap-upsell__header{padding:20px 18px 14px}.tuap-upsell__header h2{font-size:22px}.tuap-upsell__body{padding:0 18px}.tuap-upsell__footer{margin:0 18px;padding-bottom:max(16px,env(safe-area-inset-bottom))}.tuap-upsell__card{grid-template-columns:19px 46px minmax(0,1fr) auto;gap:9px}.tuap-upsell__media{width:46px;height:60px}.tuap-upsell__copy label,.tuap-upsell__price{font-size:14px}}
      @media(max-width:359px){.tuap-upsell__card{grid-template-columns:19px 42px minmax(0,1fr)}.tuap-upsell__price{grid-column:3}.tuap-upsell__media{width:42px}}
    `;
    document.head.appendChild(style);
  }

  window.__partifyRequestAerosolAddOn = function (options) {
    if (window.__partifyAddOnStyles?.active()) return Promise.resolve({ confirmed: true, addOns: [] });
    const accessory = options && options.accessory;
    if (activeRequest) return Promise.resolve({ confirmed: false, addOns: [] });
    if (!accessory || !accessory.available || !Number.isSafeInteger(Number(accessory.variantId)) || Number(accessory.variantId) <= 0 || !Number.isFinite(Number(accessory.priceCents)) || Number(accessory.priceCents) < 0) {
      return Promise.resolve({ confirmed: true, addOns: [] });
    }
    const dialog = document.createElement('dialog');
    if (typeof dialog.showModal !== 'function') return Promise.resolve({ confirmed: true, addOns: [] });
    addStyles();
    dialog.className = 'tuap-upsell';
    dialog.setAttribute('aria-labelledby', 'tuap-upsell-title');
    dialog.innerHTML = `
      <div class="tuap-upsell__header">
        <h2 id="tuap-upsell-title">Optional extras</h2>
        <p class="tuap-upsell__context" data-upsell-context></p>
        <button class="tuap-upsell__close" type="button" aria-label="Close optional extras" data-upsell-close>&times;</button>
      </div>
      <div class="tuap-upsell__body">
        <div class="tuap-upsell__card">
          <input class="tuap-upsell__check" type="checkbox" id="tuap-upsell-trigger" data-upsell-check>
          <button class="tuap-upsell__media" type="button" aria-label="View larger accessory image" aria-expanded="false" aria-controls="tuap-upsell-preview" data-upsell-image-toggle><img data-upsell-image alt=""></button>
          <div class="tuap-upsell__copy"><label for="tuap-upsell-trigger" data-upsell-title></label><p>Reusable trigger handle for your aerosol spray can</p></div>
          <strong class="tuap-upsell__price" data-upsell-price></strong>
        </div>
        <div id="tuap-upsell-preview" class="tuap-upsell__preview" data-upsell-preview hidden><img data-upsell-preview-image alt=""></div>
      </div>
      <div class="tuap-upsell__footer">
        <div class="tuap-upsell__subtotal"><span>Items subtotal</span><strong data-upsell-total aria-live="polite"></strong></div>
        <p class="tuap-upsell__notice" data-upsell-notice aria-live="polite"></p>
        <button class="tuap-upsell__primary" type="button" data-upsell-confirm>Add selected items to cart</button>
        <button class="tuap-upsell__skip" type="button" data-upsell-skip>Continue without extras</button>
      </div>`;
    const find = key => dialog.querySelector('[data-upsell-' + key + ']');
    const check = find('check');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: options.currency || window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    find('title').textContent = accessory.title || 'Aerosol spray can trigger handle';
    find('context').textContent = options.context || 'Adding your selected aerosol package';
    find('price').textContent = '+' + money(Number(accessory.priceCents));
    ['image', 'preview-image'].forEach(key => {
      find(key).src = accessory.image || '';
      find(key).alt = accessory.title || 'Aerosol spray can trigger handle';
    });
    if (!accessory.image) find('image-toggle').hidden = true;
    function refresh() {
      const base = Number(options.basePriceCents);
      find('total').parentElement.hidden = !Number.isFinite(base);
      find('total').textContent = Number.isFinite(base) ? money(base + (check.checked ? Number(accessory.priceCents) : 0)) : '';
      find('notice').textContent = (check.checked ? '1 extra selected' : 'No extras selected') + ' · Before shipping and tax';
    }
    refresh();
    return new Promise(resolve => {
      const trigger = document.activeElement;
      const previousOverflow = document.documentElement.style.overflow;
      let settled = false;
      const finish = (confirmed, includeAccessory) => {
        if (settled) return;
        settled = true;
        if (dialog.open) dialog.close();
        dialog.remove();
        document.documentElement.style.overflow = previousOverflow;
        activeRequest = null;
        if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
        resolve({ confirmed: confirmed, addOns: confirmed && includeAccessory ? [{ id: Number(accessory.variantId), quantity: 1 }] : [] });
      };
      activeRequest = { dialog: dialog };
      check.addEventListener('change', refresh);
      find('close').addEventListener('click', () => finish(false, false));
      find('skip').addEventListener('click', () => finish(true, false));
      find('confirm').addEventListener('click', () => finish(true, check.checked));
      find('image-toggle').addEventListener('click', () => {
        find('preview').hidden = !find('preview').hidden;
        find('image-toggle').setAttribute('aria-expanded', String(!find('preview').hidden));
      });
      dialog.addEventListener('cancel', event => { event.preventDefault(); finish(false, false); });
      dialog.addEventListener('close', () => finish(false, false));
      document.body.appendChild(dialog);
      try {
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        check.focus();
      } catch (error) {
        finish(false, false);
      }
    });
  };
})();
